import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import { Title } from '@angular/platform-browser';
import { DataService } from '../data.service';
import {ValidationService} from '../validation.service';
declare var $: any;
import * as Chart from 'chart.js';
import html2canvas from 'html2canvas';
@Component({
  selector: 'app-capital-growth-result',
  templateUrl: './capital-growth-result.component.html',
  styleUrls: ['./capital-growth-result.component.css']
})
export class CapitalGrowthResultComponent implements OnInit,AfterViewInit,OnDestroy {
  cgChart: any = null;
  // The chart is sized (and its axis fonts/point sizes picked) for whatever
  // width its container has when Chart.js first draws it — on mobile that's
  // the narrow phone screen. The printed page renders at a much wider
  // effective width, so without an explicit redraw at that point the chart
  // is left stranded at its small mobile size. matchMedia('print') fires
  // once the print layout is actually active — unlike 'beforeprint', which
  // isn't reliably dispatched on mobile — so resize() here reflects the
  // real print-time container width instead of the stale on-screen one.
  private _printMql = window.matchMedia ? window.matchMedia('print') : null;
  private _printMediaHandler = (e: MediaQueryListEvent) => {
    if (e.matches && this.cgChart) { this.cgChart.resize(); }
  };
  calculatedCapitalGrowth: number;
  calculatedCapitalGrowtharray:any=[];
  MapLoad = true;
  lat :number=0;
  long :number=0;
  calcData: any;
  GBPValue:number=0;
  investedTenure='';
  CaptitalGrowthinHomeCurrency:number=0;
  CaptitalGrowthinHomeCurrencyArray:any=[];
  homeCurrencyFXGrowth=0;
  propertyValue=0;
  propertyValueHomeCurrency=0;
  yearArray=[];
  gbpValuesArray: number[] = [];
  homeCurrencyValuesArray: number[] = [];
  today = new Date();
  // Whether a non-GBP home currency is set — drives home-currency content across the report.
  get hasHomeCurrency(): boolean {
    return !!this.calcData?.homecurrencyText && this.calcData.homecurrencyText !== 'GBP';
  }
  constructor(private router: Router,
              private dataService: DataService,public validation: ValidationService,
              private titleService: Title) {
    this.titleService.setTitle('Capital Growth Calculator — Report | Adventum');
  }

  ngOnInit(): void {
    this.calcData = JSON.parse(localStorage.getItem('calcData'));
	this.GBPValue=this.calcData.PropertyValue;
  this.propertyValue=this.calcData.PropertyValue;
	this.homeCurrencyFXGrowth=parseFloat(parseFloat(this.calcData.homecurrency).toFixed(4));
  this.propertyValueHomeCurrency=this.propertyValue*this.homeCurrencyFXGrowth;
	this.investedTenure=this.calcData.investedTenure;
    if (!this.dataService.EmptyNullOrUndefined(this.calcData.lat)){
      this.lat = this.calcData.lat;
    }
    if (!this.dataService.EmptyNullOrUndefined(this.calcData.long)){
      this.long = this.calcData.long;
    }
    this.calculatedCapitalGrowth = parseInt(this.calcData.PropertyValue);
    for (let i = 0; i < parseInt(this.calcData.investedTenure); i++){
      this.calculatedCapitalGrowth += parseFloat((this.calculatedCapitalGrowth * parseInt(this.calcData.capitalgrowth) / 100).toFixed(4));
      this.calculatedCapitalGrowtharray.push(parseFloat((((this.calculatedCapitalGrowth-this.propertyValue)/this.propertyValue)*100).toFixed(4)));
      this.gbpValuesArray.push(parseFloat(this.calculatedCapitalGrowth.toFixed(2)));
      if (this.hasHomeCurrency) {
        this.homeCurrencyFXGrowth=parseFloat((this.homeCurrencyFXGrowth+(this.homeCurrencyFXGrowth*parseFloat(this.calcData.fxgrowth)/100)).toFixed(4));
      }
      this.CaptitalGrowthinHomeCurrencyArray.push(parseFloat(((((this.calculatedCapitalGrowth*this.homeCurrencyFXGrowth)-this.propertyValueHomeCurrency)/this.propertyValueHomeCurrency)*100).toFixed(4)));
      this.CaptitalGrowthinHomeCurrency=parseFloat((this.calculatedCapitalGrowth*this.homeCurrencyFXGrowth).toFixed(4));
      this.homeCurrencyValuesArray.push(this.CaptitalGrowthinHomeCurrency);
      this.yearArray.push(i+1);
    }
    this.yearArray.push(this.yearArray.length+1);
  }
  ngAfterViewInit(): void {
    const canvasEl = document.getElementById('canvas') as HTMLCanvasElement;
    if (!canvasEl) return;
    const ctx = canvasEl.getContext('2d');
      const labels = this.yearArray.slice(0, this.calculatedCapitalGrowtharray.length).map((y: any) => 'Yr ' + y);
      const gbpGradient = ctx.createLinearGradient(0, 0, 0, 320);
      gbpGradient.addColorStop(0, 'rgba(74,90,133,0.18)');
      gbpGradient.addColorStop(1, 'rgba(74,90,133,0)');
      const hcGradient = ctx.createLinearGradient(0, 0, 0, 320);
      hcGradient.addColorStop(0, 'rgba(35,177,75,0.20)');
      hcGradient.addColorStop(1, 'rgba(35,177,75,0)');
      const isForeignBuyer = this.hasHomeCurrency;
      const chartDatasets: any[] = [{
        label: 'GBP Growth',
        borderColor: '#4a5a85',
        backgroundColor: gbpGradient,
        pointBackgroundColor: '#4a5a85',
        pointBorderColor: '#ffffff',
        pointBorderWidth: 2,
        pointRadius: 4,
        pointHoverRadius: 6,
        borderWidth: 2.5,
        lineTension: 0.32,
        fill: true,
        data: this.calculatedCapitalGrowtharray,
      }];
      if (isForeignBuyer) {
        chartDatasets.push({
          label: (this.calcData?.homecurrencyText || 'FX') + ' Growth',
          borderColor: '#23B14B',
          backgroundColor: hcGradient,
          pointBackgroundColor: '#23B14B',
          pointBorderColor: '#ffffff',
          pointBorderWidth: 2,
          pointRadius: 4,
          pointHoverRadius: 6,
          borderWidth: 2.5,
          lineTension: 0.32,
          fill: true,
          data: this.CaptitalGrowthinHomeCurrencyArray,
        });
      }
      this.cgChart = new (Chart as any)(ctx, {
        type: 'line',
        data: {
          labels: labels,
          datasets: chartDatasets,
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: { display: false },
          tooltips: {
            backgroundColor: '#132147',
            cornerRadius: 8,
            titleFontColor: '#fff',
            bodyFontColor: 'rgba(255,255,255,0.9)',
            borderColor: 'rgba(255,255,255,0.08)',
            borderWidth: 1,
            callbacks: {
              label: (item: any, data: any) => data.datasets[item.datasetIndex].label + ': ' + item.yLabel.toFixed(1) + '%'
            }
          },
          scales: {
            xAxes: [{
              gridLines: { display: false },
              ticks: { fontColor: 'rgba(51,58,68,0.4)', fontFamily: 'Inter', fontSize: 11, padding: 8 }
            }],
            yAxes: [{
              gridLines: { color: 'rgba(19,33,71,0.08)', zeroLineColor: 'rgba(19,33,71,0.12)', drawTicks: false },
              ticks: {
                fontColor: 'rgba(51,58,68,0.4)', fontFamily: 'Inter', fontSize: 11, padding: 8,
                callback: (value: any) => value + '%'
              }
            }]
          }
        }
      });


    if(!this.calcData.reportSavedOnServer && !this.validation.isNullEmptyUndefined(sessionStorage.getItem('UserId'))){
      this.reportSaveToServer();
    }

    if (this._printMql) { this._printMql.addEventListener('change', this._printMediaHandler); }
}

  ngOnDestroy(): void {
    if (this._printMql) { this._printMql.removeEventListener('change', this._printMediaHandler); }
  }

  startagain(): void {
    localStorage.removeItem('calcData');
    this.router.navigate(['/']);
  }

  
  printScreen() {
    window.print();
  }

  formatCurrency(value: number, currencyCode: string): string {
    if (value === null || value === undefined || isNaN(value)) return '0';
    const sym = currencyCode === 'INR' ? '₹' : (currencyCode || '');
    const abs = Math.abs(value);
    let formatted: string;
    if (currencyCode === 'INR') {
      if (abs >= 1e7) {
        formatted = (abs / 1e7).toFixed(2).replace(/\.?0+$/, '') + ' Cr';
      } else if (abs >= 1e5) {
        formatted = (abs / 1e5).toFixed(2).replace(/\.?0+$/, '') + ' L';
      } else {
        formatted = Math.round(abs).toLocaleString('en-IN');
      }
    } else if (abs >= 1e9) {
      formatted = (abs / 1e9).toFixed(2).replace(/\.?0+$/, '') + 'B';
    } else if (abs >= 1e6) {
      formatted = (abs / 1e6).toFixed(2).replace(/\.?0+$/, '') + 'M';
    } else {
      formatted = Math.round(abs).toLocaleString('en-US');
    }
    return (value < 0 ? '-' : '') + sym + formatted;
  }


  reportSaveToServer(){
    setTimeout(() => {
      if (!this.calcData.reportSavedOnServer && !this.validation.isNullEmptyUndefined(sessionStorage.getItem('UserId'))) {
        $(".noprint").addClass("displaynone");
        const data = document.getElementById('contentToConvert');
        html2canvas(data,
          {
            scrollY: -window.scrollY,
            logging: true,
            useCORS: true,
            allowTaint: true
          }).then(canvas => {
            let contentDataURL = canvas.toDataURL('image/png');
            contentDataURL=contentDataURL.replace("data:image/png;base64,","");
            const Data = { "UserId": sessionStorage.getItem('UserId'), "CalculatorId": localStorage.getItem('CalculatorType').toString(), "ResultImageBase64String": contentDataURL };
            const Response = this.dataService.PostAdventumRequest('v1/saveuserresult', Data).subscribe((response) => {
              this.calcData.reportSavedOnServer=true;
              localStorage.setItem("calcData",JSON.stringify(this.calcData));
            });
          });
          $(".noprint").removeClass("displaynone");
      }
    }, 5000);
    
  }
}
